import List from 'antd-mobile/lib/list';
export default List;



// WEBPACK FOOTER //
// ./components/list/index.tsx